import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import CloseIcon from '@material-ui/icons/Close'

interface Props {
  title: string
  onClose?: () => void
}

export default function HeaderDetails({ title, onClose }: Props) {
  return (
    <div>
      <Box
        paddingY={1}
        paddingX={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6" children={title} />
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
    </div>
  )
}
